export const LOADING_REQUEST = 'LOADING_REQUEST';
export const LOADING_FAILURE = 'LOADING_FAILURE';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';
